import { render, staticRenderFns } from "./add-update-user-role.vue?vue&type=template&id=5a4ebd2c&scoped=true"
import script from "./add-update-user-role.vue?vue&type=script&lang=js"
export * from "./add-update-user-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ebd2c",
  null
  
)

export default component.exports